import RefuseBanMessage from './components/RefuseBanMessage'

const HardHitBanResultPage = () => {
  return (
    <RefuseBanMessage />
  )
}

export default HardHitBanResultPage
